import { Component, EventEmitter, Input, Output } from '@angular/core';
import { id } from 'date-fns/locale';

@Component({
    selector: 'sidebar-item',
    templateUrl: './sidebar-item.component.html',
    styleUrls: ['./sidebar-item.component.scss'],
    standalone: false
})
export class SidebarItemComponent {
  @Output('p-click') click = new EventEmitter<MouseEvent>();
  @Input('p-name') name: string;
  @Input('p-image') image: string;
  @Input('p-id') id: string;
  @Input() novoMenu: boolean;

  handleClick(event: MouseEvent) {
    this.click.emit(event);
  }

  isSelected(id: string): boolean{
    if(id == "7") return false; // para não marcar a opção Rede de Descontos
    if(sessionStorage.getItem('selectedMenu')) return sessionStorage.getItem('selectedMenu') == id;

    if(!sessionStorage.getItem('selectedMenu') && id == "0") return true; // para marcar a opção Home
    if(sessionStorage.getItem('selectedMenu') && id == "-1") return true; // para marcar a opção Notificações

    return false;
  }
}
